import * as React from 'react';

import { ZoomOut } from '../../../../../components/Icons';
import { ControlButton } from '../../../../../components/ControlButton';

import * as styles from './styles.css';

export interface IZoomOutButtonProps {
  map: YMaps.Map;
}

export const ZoomOutButton: React.FC<IZoomOutButtonProps> = props => {
  const { map } = props;

  const handleZoomOutClick = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      event.preventDefault();

      const zoom = map.getZoom();
      const [minZoom] = map.zoomRange.getCurrent();
      if (zoom <= minZoom) {
        return;
      }

      return map.setZoom(zoom - 1);
    },
    [map],
  );

  return (
    <ControlButton className={styles['button']} onClick={handleZoomOutClick}>
      <ZoomOut />
    </ControlButton>
  );
};
